import { Link } from "react-router-dom";
import { FileText, Download, Lock, Building2, UserRound, MapPin } from "lucide-react";
import { pdfUrl } from "@/lib/api";

const DocRow = ({ cf, d, i }) => (
  <div
    data-testid={`doc-row-${d.tipo}`}
    className={`fade-up flex flex-col gap-3 border-b border-slate-100 px-5 py-4 last:border-0 sm:flex-row sm:items-center sm:justify-between ${d.disponibile ? "" : "opacity-60"}`}
    style={{ animationDelay: `${i * 60}ms` }}
  >
    <div className="flex items-start gap-3">
      <span className={`mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-md ${d.disponibile ? "bg-blue-50 text-blue-600" : "bg-slate-100 text-slate-400"}`}>
        {d.disponibile ? <FileText className="h-4 w-4" /> : <Lock className="h-4 w-4" />}
      </span>
      <div>
        <p className="font-medium text-slate-900">{d.titolo}</p>
        <p className="font-mono text-[11px] uppercase tracking-wider text-slate-400">{d.codice}</p>
      </div>
    </div>
    {d.disponibile ? (
      <div className="flex gap-2 pl-12 sm:pl-0">
        <Link
          to={`/documento/${cf}/${d.tipo}`}
          data-testid={`doc-view-button-${d.tipo}`}
          className="rounded-md bg-slate-900 px-3.5 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-600"
        >
          Visualizza
        </Link>
        <a
          href={pdfUrl(cf, d.tipo)}
          data-testid={`doc-pdf-button-${d.tipo}`}
          className="inline-flex items-center gap-1.5 rounded-md border border-slate-200 px-3.5 py-2 text-sm font-medium text-slate-700 transition-colors hover:border-slate-900 hover:text-slate-900"
        >
          <Download className="h-3.5 w-3.5" /> PDF
        </a>
      </div>
    ) : (
      <span data-testid={`doc-unavailable-${d.tipo}`} className="pl-12 text-sm text-slate-400 sm:pl-0">Non disponibile</span>
    )}
  </div>
);

const Meta = ({ icon: Icon, label, value }) => (
  <div className="flex gap-3">
    <Icon className="mt-0.5 h-4 w-4 shrink-0 text-slate-400" />
    <div>
      <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">{label}</p>
      <p className="text-sm text-slate-700">{value || "—"}</p>
    </div>
  </div>
);

export const CondominioResult = ({ c }) => {
  const place = [c.cap, c.citta, c.provincia && `(${c.provincia})`].filter(Boolean).join(" ");
  const addr = [c.indirizzo, place].filter(Boolean).join(", ");
  return (
    <article data-testid={`result-card-${c.codice_fiscale}`} className="fade-up grid overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_1px_0_rgba(15,23,42,0.04),0_20px_40px_-24px_rgba(15,23,42,0.25)] lg:grid-cols-[340px_1fr]">
      <div className="space-y-5 border-b border-slate-200 bg-slate-50/70 p-6 lg:border-b-0 lg:border-r">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-wider text-emerald-700">Condominio verificato</p>
          <h3 data-testid="result-condominio-name" className="mt-1 font-heading text-xl font-bold tracking-tight text-slate-900">{c.nome}</h3>
          <p data-testid="result-condominio-cf" className="mt-1 font-mono text-sm text-slate-500">C.F. {c.codice_fiscale}</p>
        </div>
        <Meta icon={MapPin} label="Indirizzo" value={addr} />
        <Meta icon={UserRound} label="Amministratore" value={c.amministratore_nome} />
        {c.amministratore_email && <Meta icon={Building2} label="Contatti amministratore" value={[c.amministratore_email, c.amministratore_telefono].filter(Boolean).join(" · ")} />}
      </div>
      <div>
        <p className="px-5 pt-5 text-[11px] font-semibold uppercase tracking-wider text-slate-400">Documenti</p>
        {c.documenti.map((d, i) => <DocRow key={d.tipo} cf={c.codice_fiscale} d={d} i={i} />)}
      </div>
    </article>
  );
};
